// employeeFlow.reducer.js

import { SET_ADMIN_FACILITY, SET_HOSTEL_FACILITY } from "./employeeFlow.type";

const initialState = {
  hostelFacilityForStaff: false,
  adminhospitalShow:true,
  employeeFlowInitialized:false,
  uiStage: null
};

export default function employeeFlowReducer(state = initialState, action) {
  switch (action.type) {
  
 case SET_HOSTEL_FACILITY:
  return {
    ...state,
    hostelFacilityForStaff: action.payload,
  };

   case SET_ADMIN_FACILITY:
  return {
    ...state,
    adminhospitalShow: action.payload,
  };
case "SET_EMPLOYEE_FLOW_INITIALIZED":
  return {
    ...state,
    employeeFlowInitialized: true,
  };
  case "SET_EMPLOYEE_FLOW_UI_STAGE":
  return {
    ...state,
    uiStage: action.payload,
  };
    default:
      return state;
  }
}
